'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userProfileCompleteness = require('./user-profile-completeness.html');

var _userProfileCompleteness2 = _interopRequireDefault(_userProfileCompleteness);

var _userProfileCompleteness3 = require('./user-profile-completeness.controller');

var _userProfileCompleteness4 = _interopRequireDefault(_userProfileCompleteness3);

require('./user-profile-completeness.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProfileCompletenessComponent = {
  restrict: 'E',
  bindings: {
    profileItems: '<',
    isClient: '<',
    clientInfo: '<',
    providerInfo: '<',
    userId: '<'
  },
  template: _userProfileCompleteness2.default,
  controller: _userProfileCompleteness4.default,
  controllerAs: 'vm'
};

exports.default = userProfileCompletenessComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-profile-completeness/user-profile-completeness.component.js
 **/